export const validatePassword = (password: string): boolean => {
  const regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@#$%^&+=!.])(?=.{8,})(?!.*\s)/;
  return regex.test(password);
};
